/**
 *
 * @module exchangeGrant
 *
 */

import Check from 'check-types';
import Grant from './grant';
import TokenRequestBuilder from './tokenRequestBuilder';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString,
    instanceStrict
} = Check.assert;

/**
 *
 * @class ExchangeGrant
 * @extends {TokenRequestBuilder}
 * @desc Provides an implementation for ITokenRequestBuilder used to exchange a grant for an AccessContext.
 *
 */
export default class ExchangeGrant extends TokenRequestBuilder {

    /**
     *
     * @param {Grant} grant - The grant to build a TokenRequest for.
     * @param {String} subjectType - The subject_token_type of the grant.
     *
     */
    constructor(grant, subjectType) {

        const errorMessage = {
            ctor: 'ExchangeGrant(grant, subjectType)',
            get grant() {
                return `${this.ctor} needs Grant instance`;
            },
            get subjectType() {
                return `${this.ctor} subjectType should be a String with length`;
            }
        };

        instanceStrict(
            grant,
            Grant,
            errorMessage.grant,
            InvalidArgumentException
        );

        nonEmptyString(subjectType, errorMessage.subjectType, InvalidArgumentException);

        super();

        /**
         *
         * @access public
         * @type {Grant}
         *
         */
        this.grant = grant;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.subjectType = subjectType;

        /**
         *
         * @access private
         * @type {String}
         *
         */
        this.grantType = 'urn:ietf:params:oauth:grant-type:token-exchange';

        /**
         *
         * @desc token data, used in a TokenRequest
         *
         */
        this.tokenData.subject_token_type = this.subjectType;
        this.tokenData.subject_token = this.grant.assertion;

    }

}



// WEBPACK FOOTER //
// ./src/services/token/exchangeGrant.js